import React from 'react';
import './ExecutiveCouncil.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import executiveMembers from '../../data/executiveMem';

const ExecutiveCouncil = () => {
  // Sort members by hierarchy and group them by hierarchy level
  const sortedMembers = [...executiveMembers].sort((a, b) => a.hierarchy - b.hierarchy);
  
  // Group members by hierarchy
  const membersByHierarchy = sortedMembers.reduce((acc, member) => {
    if (!acc[member.hierarchy]) {
      acc[member.hierarchy] = [];
    }
    acc[member.hierarchy].push(member);
    return acc;
  }, {});

  return (
    <div className="executive-council-page">
      <Navbar />
      
      <div className="executive-council-container">
        <div className="page-header">
          <h1>Executive Council</h1>
          <div className="header-underline"></div>
        </div>
        
        <div className="exec-council-members">
          {/* <h2>Current Members</h2> */}
          <div className="exec-members-grid">
            {Object.entries(membersByHierarchy).map(([hierarchyLevel, members]) => (
              <div key={hierarchyLevel} className={`exec-hierarchy-row hierarchy-${hierarchyLevel}`}>
                {members.map(member => (
                  <div key={member.id} className="exec-member-card" id={`exec-member-${member.id}`}>
                    <div className="exec-member-info">
                      <h3 className="exec-member-name">{member.name}</h3>
                      <p className="exec-member-designation">{member.designation}</p>
                      <p className="exec-member-description">{member.info}</p>
                      {/* <div className="exec-member-contact">
                        <i className="fas fa-phone"></i>
                        <span>{member.mobile}</span>
                      </div> */}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ExecutiveCouncil;